<template>
   <div>
      <b-row>
         <b-col>
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                aria-controls="conference-table"/>
         </b-col>
         <b-col md="auto">
            <b-form inline>
               <b-form-group class="mb-2 mr-sm-2 mb-sm-0">
                  <b-input v-debounce:500="fetchOrders" v-model="articleFilter" class="secondary"
                           placeholder="Article"></b-input>
               </b-form-group>
               <b-form-group class="mb-2 mr-sm-2 mb-sm-0">
                  <b-input v-debounce:500="fetchOrders" v-model="orderCodeFilter" class="secondary"
                           placeholder="Order Code"></b-input>
               </b-form-group>
               <b-form-group class="mb-2 mr-sm-2 mb-sm-0">
                  <b-input v-debounce:500="fetchOrders" v-model="pbArticleNumberFilter" class="secondary"
                           placeholder="PB Article Number"></b-input>
               </b-form-group>
               <b-form-group class="mb-2 mr-sm-2 mb-sm-0">
                  <b-form-select class="secondary form-control" v-model="filter.confirmed"
                                 :options="confirmedOptions"></b-form-select>
               </b-form-group>
               <b-form-group class="mb-2 mb-sm-0">
                  <b-form-select class="secondary form-control" v-model="filter.newDevelopmentsOnly"
                                 :options="newDevelopmentsOnlyOptions"></b-form-select>
               </b-form-group>
            </b-form>
         </b-col>
      </b-row>
      <b-table @filtered="onFiltered"
               :busy="busy"
               :current-page="currentPage"
               :per-page="perPage"
               striped
               :fields="columns"
               :items="supplierOrders">
         <template v-slot:cell(supplierArticleCode)="row">
            Article: {{ row.item.supplierArticleCode ? row.item.supplierArticleCode : '-' }}<br><br>
            PB Article: {{ row.item.articleCode }}

         </template>
         <template v-slot:cell(img)="row">
            <b-img class="thumbnail" style="max-width: 100px;" :src="fileResourceUrl(row.item.img)"/>
         </template>
         <template v-slot:cell(requestedDeliveryDate)="row">
            {{ row.item.requestedDeliveryDate | moment("DD.MM.YYYY") }}
         </template>
         <template v-slot:cell(confirmedDeliveryDate)="row">
            {{ row.item.confirmedDeliveryDate | moment("DD.MM.YYYY") }}
         </template>
         <template v-slot:cell(orderDate)="row">
            {{ row.item.orderDate | moment("DD.MM.YYYY") }}
         </template>
         <template v-slot:cell(action)="row">
            <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
               <template v-slot:button-content>
                  <i class="fal fa-ellipsis-v-alt"></i>
               </template>
               <b-dropdown-item v-b-modal.editModalUser @click.native="openEditModal(row.item)">
                  <i class="fal mr-2 fa-fw fa-user-edit"></i> Edit
               </b-dropdown-item>
               <b-dropdown-item @click.native="openModal(row.item)">
                  <i class="fal mr-2 fa-fw fa-envelope"></i> Label
               </b-dropdown-item>
            </b-dropdown>

         </template>
         <template v-slot:cell(openQty)="row">
            <nobr>Order Qty: {{ row.item.amount}}</nobr><br>
            <nobr>Open Qty: {{ row.item.amount - row.item.deliveredAmount }}</nobr>
         </template>
      </b-table>
      <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="conference-table"/>
      <b-modal v-model="showModal" ok-title="Save" @ok="$refs.labelForm.submitForm($event)" title="Label Form">
         <label-form :supplier-id="supplierId"  ref="labelForm" @submitted="handleFormSubmitted" :orderPosition="orderPosition"></label-form>
      </b-modal>
      <b-modal v-model="showModalEditModal" ok-title="Save" @ok="$refs.labelForm.submitForm($event)" title="Edit">
         <edit-form ref="labelForm" @submitted="showModalEditModal = false; fetchOrders()"
                   :supplier-id="supplierId" :orderPositionUpdate="orderPosition"></edit-form>
      </b-modal>
   </div>

</template>

<script>

import SupplierOrderAPI from "@shared/_api/supplierOrder";
import LabelForm from "@client/src/viewsShop/pages/Supplier/LabelForm";
import EditForm from "@client/src/viewsShop/pages/Supplier/EditForm";

export default {
   name: 'SupplierOrders',
   components: {LabelForm, EditForm},
   data() {
      return {
         supplierId: null,
         articleFilter: '',
         orderCodeFilter: '',
         pbArticleNumberFilter: '',
         showModal: false,
         showModalEditModal: false,
         orderPosition: {},
         busy: false,
         filter: {
            confirmed: null,
            newDevelopmentsOnly: null
         },
         confirmedOptions: [{value: null, text: 'Select Confirmation Status'},
            {value: '0', text: 'Not confirmed'},
            {value: '1', text: 'Confirmed'}],
         newDevelopmentsOnlyOptions: [{value: null, text: 'Select Development'},
            {value: '0', text: 'For bulk/samples only'},
            {value: '1', text: 'For new developments only'}],
         currentPage: 1,
         totalRows: null,
         perPage: 10,
         columns: [{name: 'img', label: '', key: 'img', align: 'left'},
            {
               name: 'supplierArticleCode',
               label: 'Article',
               align: 'left',
               key: 'supplierArticleCode',
               sortable: true
            },
            {name: 'orderCode', label: 'Order Code', key: 'orderCode'},
            {
               name: 'supplierOrderCode',
               label: 'Supplier Order Code',
               key: 'supplierOrderCode',
               sortable: true
            },
            {
               name: 'requestedDeliveryDate',
               label: 'Requested Devlivery Date',
               key: 'requestedDeliveryDate',
               sortable: true
            },
            {
               name: 'confirmedDeliveryDate',
               label: 'Confirmed Delivery Date',
               key: 'confirmedDeliveryDate',
               sortable: true

            },
            {name: 'size', label: 'Size', key: 'size'},
            {
               key: 'openQty',
               label: 'Open qty',
            },
            {name: 'price', label: 'Price', align: 'left'},
            {name: 'supplierColor', label: 'Color', align: 'left', key: 'supplierColor'},
            {name: 'model', label: 'Model', align: 'left', key: 'model'},
            {
               name: 'orderDate',
               label: 'Order Date',
               align: 'left',
               key: 'orderDate',
               sortable: true
            },
            {name: 'positionInfo', label: 'Position Info ', align: 'left', key: 'positionInfo'},
            {name: 'orderInfo', label: 'Order Info', align: 'left', key: 'orderInfo'},
            {name: 'deliveryComment', label: 'Supplier Info', align: 'left', key: 'deliveryComment'},

            {name: 'action', key: 'action', align: 'left'}],
         supplierOrders: null
      }
   },
   methods: {
      onFiltered(filteredItems) {
         this.totalRows = filteredItems.length;
         this.currentPage = 1;
      },
      openEditModal(order) {
         this.showModalEditModal = true;
         this.orderPosition = {
            id: order.id,
            confirmedDeliveryDate: order.confirmedDeliveryDate,
            deliveryComment: order.deliveryComment
         };
      },
      openModal(order) {
         this.showModal = true;
         this.orderPosition = {id: order.id, sizeId: order.sizeId};
      },
      handleFormSubmitted() {
         this.showModal = false;
         this.fetchOrders();
      },
      fetchOrders: function () {
         this.busy = true;

         SupplierOrderAPI.getOrders(this.supplierId, {
            confirmed: this.filter.confirmed,
            newDevelopmentsOnly: this.filter.newDevelopmentsOnly
         }).then(result => {
            let mappedAndFiltered = result.map(obj => {
               return {
                  ...obj,
                  color: obj.articleBase.color,
                  supplierColor: obj.articleBase.supplierColor,
                  img: obj.articleBase.img,
                  articleCode: obj.articleBase.articleCode,
                  supplierArticleCode: obj.articleBase.supplierArticleCode,
                  artFarbe: obj.articleBase.artFarbe,
                  artikel: obj.articleBase.artikel,
                  liefArtikel: obj.articleBase.liefArtikel,
                  bild: obj.articleBase.bild,
                  liefFarbe: obj.articleBase.liefFarbe
               };
            }).flat().filter(obj => {
               return (!this.articleFilter || obj.supplierArticleCode.toLowerCase().indexOf(this.articleFilter.toLowerCase()) !== -1)
                   && (!this.orderCodeFilter || obj.orderCode.toLowerCase().indexOf(this.orderCodeFilter.toLowerCase()) !== -1)
                   && (!this.pbArticleNumberFilter || obj.articleCode.toLowerCase().indexOf(this.pbArticleNumberFilter.toLowerCase()) !== -1)
            });

            this.supplierOrders = mappedAndFiltered;
            this.totalRows = mappedAndFiltered.length;
         }).finally(() => {
            this.busy = false;
         });
      }
   },
   watch: {
      filter: {
         handler(oldValue, newValue) {
            const newQuery = this.$_.omitBy(newValue, this.$_.isNil);

            if (!this.$_.isEqual(newQuery, this.$route.query)) {
               this.$router.replace({
                  query: newQuery
               }).catch(err => {
                  if (err.name !== 'NavigationDuplicated') {
                     throw err;
                  }
               });
            }
         },
         deep: true
      },
      '$route': {
         handler() {
            // Check if 'confirmed' parameter exists in the query and is not null or undefined
            if (this.$route.query.confirmed != null) {
               this.filter.confirmed = this.$route.query.confirmed;
            } else {
               this.filter.confirmed = null;
            }

            // Check if 'newDevelopmentsOnly' parameter exists in the query and is not null or undefined
            if (this.$route.query.newDevelopmentsOnly != null) {
               this.filter.newDevelopmentsOnly = this.$route.query.newDevelopmentsOnly;
            } else {
               this.filter.newDevelopmentsOnly = null;
            }
            this.supplierId = this.$route.params.supplierId;
            this.fetchOrders();
         },
         immediate: true
      }
   }
}
</script>

<style lang="scss" scoped>
</style>